import { Translate } from '@change-corgi/core/react/i18n';
import { SocialButton } from '@change-corgi/design-system-legacy/components/social';
import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';
import { usePhoto } from '../../hooks/photo';

import { usePetitionHeadingMobile } from './hooks/usePetitionHeadingMobile';

export function NativeShareMobile(): JSX.Element {
	const photo = usePhoto();
	const isMobile = useIsMobile();
	const { data } = usePetitionHeadingMobile();
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	const ShareAction = data.shareAction?.ShareAction;

	return (
		<Box
			data-testid="native-share-mobile"
			data-qa="native-share-mobile"
			sx={{
				position: 'sticky',
				height: 0,
				zIndex: 1,
				top: 0,
				display: 'flex',
				justifyContent: 'flex-end',
			}}
		>
			{isMobile && photo && ShareAction && (
				<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
					<Box>
						<ShareAction>
							<SocialButton
								channel="mobileNativeShare"
								iconOnly
								size="large"
								data-qa="native-share-button"
								data-testid="native-share-button"
								sx={{
									// This is doing a ton of overrides of DSLegacy's styles, which is hacky and error-prone,
									// especially because switching theme can affect it. There should just be a "circular icon
									// button" in the DS, but no point adding that ot the legacy DS.
									marginTop: 20,
									marginRight: 16,
									width: 50,
									height: 50,
									padding: '11px !important',
									minWidth: '50px !important',
									minHeight: '50px !important',
									borderRadius: '50% !important',
									borderWidth: 0,
									'&:before': {
										borderWidth: 0,
									},
									...(isSunriseEnabled && {
										'&:active, &:focus, &:hover': {
											borderWidth: '2px',
											borderStyle: 'solid',
											borderColor: 'sunrise.semantic.stroke.focus',
										},
										'&:active:before, &:focus:before, &:hover:before': {
											backgroundColor: 'transparent',
										},
									}),
									boxShadow: '0px 2px 12px 0px rgba(58, 41, 62, 0.25)',
								}}
							>
								<Translate value="corgi.petition_gamma.share.mobile_native_share" />
							</SocialButton>
						</ShareAction>
					</Box>
				</DesignSystemLegacy>
			)}
		</Box>
	);
}
